import SideModal from './SideModal';

export default SideModal;